import { render, staticRenderFns } from "./OptionsKids.vue?vue&type=template&id=646f4900&scoped=true"
import script from "./OptionsKids.vue?vue&type=script&lang=js"
export * from "./OptionsKids.vue?vue&type=script&lang=js"
import style0 from "./OptionsKids.vue?vue&type=style&index=0&id=646f4900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646f4900",
  null
  
)

export default component.exports